import { render, staticRenderFns } from "./bidding08.vue?vue&type=template&id=6cb2f665&scoped=true&"
import script from "./bidding08.vue?vue&type=script&lang=js&"
export * from "./bidding08.vue?vue&type=script&lang=js&"
import style0 from "./bidding08.vue?vue&type=style&index=0&id=6cb2f665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2f665",
  null
  
)

export default component.exports